import Component from "../../component";

export default class MainNavigation extends Component{

    documentMain = null;

    ready() {
        this.documentMain = document.querySelector('.document-main');
        this.changeHeaderTypeEvent = new CustomEvent("changeHeaderTypeEvent");
        window.addEventListener('scroll', () => this.scrollHandler());

    }

    scrollHandler()
    {
        if (this.component.offsetHeight < window.scrollY) {
            if(this.component.classList.contains('sticky') == false) {
                this.documentMain.style.marginTop = `${this.component.offsetHeight}px`;
                this.component.classList.add('sticky');
            }
        } else {
            if(this.component.classList.contains('sticky')) {
                this.documentMain.style.marginTop = `0px`;
                this.component.classList.remove('sticky');
                window.dispatchEvent(this.changeHeaderTypeEvent);
            }
        }
    }

}